/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
*/
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {entityId} from '@ion/core/src/services/ConnectUtils';
import {useAuthenticatedUser} from '../pages/admin/users/useAuthenticatedUser';
import {globalGroupSelector} from '../store/selectors/global-group';

/**
 * Custom hook for retrieving the current global group / account id.
 */
export const useCurrentGlobalGroupId = () => {
  const globalGroup                       = useSelector(globalGroupSelector);
  const {account}                         = useAuthenticatedUser();
  const [globalGroupId, setGlobalGroupId] = useState(entityId(globalGroup || account));
  useEffect(() => {
    setGlobalGroupId(entityId(globalGroup || account));
  }, [globalGroup, account]);
  return globalGroupId;
};
export default useCurrentGlobalGroupId;
